<template>
  <div class="imgUpload" :style="'width:'+width+';height:'+height" v-if="isOnline">
      <img :src="url" class="img" v-if="url!=null && exists"/>
      
      <img src="../assets/logo192.png"  v-if="!exists"/>
     <div class="buttonUploadImg" v-show="role=='owner' || role=='admin'" v-if="upload">
        <s-button label="Changer" theme="is-small is-primary" icon="upload" @onclick="$emit('onclick')"/>
     </div>
    
  </div>
  
</template>
<style >
    .img {
      max-width:100%;
      max-height:100%;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    #fileInput {
        display: none;
    }
    .buttonUploadImg {
      margin-left: auto;
      margin-right: auto;
      margin-top: 10px;
    }
    .buttonUploadImg:hover{
      cursor: pointer;
    }
    .imgUpload {
      text-align: center;
      display: table-cell;
      vertical-align: middle;
      position: relative;
    }
</style>
<script>
import firebase from "firebase"

export default {
  props: ["pathFile", "role", "width", "height", "upload", "exists"],
  
  data() {
    return {
      hasImage: false,
      url: null
    }
  },
  
  methods: {
       initImage() {
         if (this.exists && this.isOnline) {
          var storageRef = firebase.storage().ref();
            try {
                var storageInst = storageRef.child(this.pathFile);
                storageInst.getDownloadURL().then(url=>{
                  this.url = url;
                })
                .catch(error=>{
                  console.log("PROBLEME");
                })
            }
            catch (error) {
              console.log(error);
              console.log(this.pathFile);
            console.log(storageInst);
          
            }
         }
          
          
       }
    },
    mounted() {
          this.initImage();
    }
}
</script>
